import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from '@/locales/zh-CN'
import enUS from '@/locales/en-US'

Vue.use(VueI18n)

function normalizeLang(lang) {
  if (!lang) return 'zh-CN'
  const l = lang.toLowerCase()
  if (l.startsWith('zh')) return 'zh-CN'
  if (l.startsWith('en')) return 'en-US'
  return 'zh-CN'
}

const locale = normalizeLang(
  navigator.language || navigator.browserLanguage || navigator.userLanguage
)

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'zh-CN',
  silentFallbackWarn: true,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
